(function() {
  'use strict';

  angular.module('app').factory('PdmServices', PdmServices);

  function PdmServices(WebApiService) {
    return {
      calcPdmPrice: function calcPdmPrice(protoId, seasonId) {
        return WebApiService.get('/api/PDM/calcPdmPrice', {
          protoId: protoId,
          seasonId: seasonId
        });
      }
    };
  }
})();
